// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from "components/MDButton";
import MDDatePicker from "components/MDDatePicker";
import { useMemo, useState } from "react";
import FormField from "components/FormField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { BorderBottom } from "@mui/icons-material";
import colors from "assets/theme/base/colors";
import AutocompleteWithPagination from "components/AutocompleteWithPagination";
import crudsService from "services/cruds-service";
import { Switch } from "@mui/material";

const FilterDonation = ({ setFilterUrl, setFilterUrlForSum }) => {
  const [range, setRange] = useState("custom");
  const [status, setStatus] = useState("");
  const [dateField, setDateField] = useState("date_created");
  const [amountFrom, setAmountFrom] = useState("");
  const [amountTo, setAmountTo] = useState("");
  const [influencers, setInfluencers] = useState("");

  const [donation, setDonation] = useState({
    from: "2025-01-01",
    to: "2027-12-31",
    date: null,
    txt: "",
    noUser: false,
  });

  const getRangeDates = (range) => {
    const now = new Date();
    let from, to;

    // End is always end of today
    to = new Date();
    to.setUTCHours(23, 59, 59, 999);

    switch (range) {
      case "today": {
        from = new Date();
        from.setUTCHours(0, 0, 0, 0);
        break;
      }

      case "week": {
        from = new Date();
        from.setDate(from.getDate() - 7);
        from.setUTCHours(0, 0, 0, 0);
        break;
      }

      case "month": {
        from = new Date();
        from.setMonth(from.getMonth() - 1);
        from.setUTCHours(0, 0, 0, 0);
        break;
      }

      case "year": {
        from = new Date();
        from.setFullYear(from.getFullYear() - 1);
        from.setUTCHours(0, 0, 0, 0);
        break;
      }

      default:
        return null;
    }

    return {
      from: from.toISOString(),
      to: to.toISOString(),
    };
  };

  const handleRangeChange = (e) => {
    const value = e.target.value;
    setRange(value);

    if (value !== "custom") {
      const dates = getRangeDates(value);
      setDonation((prev) => ({
        ...prev,
        ...dates,
      }));
    }
  };

  const onFilterHandller = async () => {
    let filter = "";
    let filter1 = "";

    if (donation.txt) {
      filter +=
        `&filter[_and][3][_or][1][OrderId][_contains]=${donation.txt}` +
        `&filter[_and][3][_or][2][TxnResult][_contains]=${donation.txt}` +
        `&filter[_and][3][_or][3][country][_contains]=${donation.txt}` +
        `&filter[_and][3][_or][6][user][_contains]=${donation.txt}` +
        `&filter[_and][3][_or][7][project][_contains]=${donation.txt}`;
      filter1 +=
        `&filter[_and][3][_or][1][OrderId][_contains]=${donation.txt}` +
        `&filter[_and][3][_or][2][TxnResult][_contains]=${donation.txt}` +
        `&filter[_and][3][_or][3][country][_contains]=${donation.txt}` +
        `&filter[_and][3][_or][6][user][_contains]=${donation.txt}` +
        `&filter[_and][3][_or][7][project][_contains]=${donation.txt}`;
    }

    if (donation.from && donation.to) {
      filter += `&filter[${dateField}][_gte]=${donation.from}&filter[${dateField}][_lte]=${donation.to}`;
      filter1 += `&filter[${dateField}][_gte]=${donation.from}&filter[${dateField}][_lte]=${donation.to}`;
    }

    filter += `&filter[user_id][_null]=${donation.noUser}`;
    filter1 += `&filter[user_id][_null]=${donation.noUser}`;

    if (status) {
      filter += `&filter[donation_status][_eq]=${status}`;
    }

    if (amountFrom) {
      filter += `&filter[cost][_gte]=${amountFrom}`;
      filter1 += `&filter[cost][_gte]=${amountFrom}`;
    }
    if (amountTo) {
      filter += `&filter[cost][_lte]=${amountTo}`;
      filter1 += `&filter[cost][_lte]=${amountTo}`;
    }
    if (influencers) {
      filter += `&filter[donation_items][influencers][_eq]=${influencers.id}`;
      filter1 += `&filter[donation_items][influencers][_eq]=${influencers.id}`;
    }

    setFilterUrl(filter);
    setFilterUrlForSum(filter1);
  };

  const getUserData = async (name, page, search) => {
    const usersData = await crudsService.getAllData(
      `users?fields=id,first_name,last_name&filter[role][_eq]=0476f14d-84d3-44e3-a9d0-735e97e33cf5${
        search && `&filter[first_name][_contains]=${search}`
      }&page=${page}&limit=${crudsService.getLimit()}`,
    );

    return usersData.data;
  };

  return (
    <Grid container spacing={3} py={5} px={2}>
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        sx={{ borderBottom: 1, py: 2, borderColor: colors.light.main }}
      >
        <FormField
          label="المتبرع / البلد / المشروع / رقم الطلب / حالة الطلب"
          placeholder=""
          name="txt"
          value={donation.txt}
          onChange={(e) =>
            setDonation({
              ...donation,
              [e.target.name]: e.target.value,
            })
          }
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ borderBottom: 1, py: 2, borderColor: colors.light.main }}
      >
        <FormField
          select
          label="حالة الدفع"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          SelectProps={{ native: true }}
        >
          <option value="">الكل</option>
          <option value="paid">ناجحة</option>
          <option value="pending">قيد المعالجة</option>
          <option value="failed">فاشلة</option>
          <option value="refunded">إعادة</option>
        </FormField>
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ borderBottom: 1, py: 2, borderColor: colors.light.main }}
      >
        <FormControl fullWidth>
          <MDTypography>نوع التاريخ</MDTypography>
          <RadioGroup
            row
            value={dateField}
            onChange={(e) => setDateField(e.target.value)}
          >
            <FormControlLabel
              // style={{ fontWeight: "normal", fontSize: 111 }}
              value="TransactionDate"
              control={<Radio />}
              label="تاريخ التحصيل"
            />
            <FormControlLabel
              value="date_created"
              control={<Radio />}
              label="تاريخ العملية"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid
        item
        xs={12}
        // sx={{ borderBottom: 1, py: 2, borderColor: colors.light.main }}
      >
        <FormControl>
          <MDTypography>الفترة الزمنية</MDTypography>
          <RadioGroup row value={range} onChange={handleRangeChange}>
            <FormControlLabel value="today" control={<Radio />} label="اليوم" />
            <FormControlLabel
              value="week"
              control={<Radio />}
              label="آخر 7 أيام"
            />
            <FormControlLabel
              value="month"
              control={<Radio />}
              label="آخر شهر"
            />
            <FormControlLabel
              value="year"
              control={<Radio />}
              label="آخر سنة"
            />
            <FormControlLabel value="custom" control={<Radio />} label="مخصص" />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        sx={{ borderBottom: 1, py: 2, borderColor: colors.light.main }}
      >
        <MDDatePicker
          onChange={(event, value) => {
            setRange("custom");
            setDonation({ ...donation, from: value });
          }}
          value={donation.from}
          name="from"
          input={{
            placeholder: "من",
            fullWidth: true,
            label: "التاريخ من",
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        sx={{ borderBottom: 1, py: 2, borderColor: colors.light.main }}
      >
        <MDDatePicker
          onChange={(event, value) => {
            setRange("custom");
            setDonation({ ...donation, to: value });
          }}
          value={donation.to}
          name="to"
          input={{
            placeholder: "إلى",
            label: "التاريخ إلى",
            fullWidth: true,
          }}
        />
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderBottom: 1, py: 2, borderColor: colors.light.main }}
      >
        <FormField
          type="number"
          label="المبلغ من"
          value={amountFrom}
          onChange={(e) => setAmountFrom(e.target.value)}
        />
      </Grid>
      <Grid
        item
        xs={6}
        sx={{ borderBottom: 1, py: 2, borderColor: colors.light.main }}
      >
        <FormField
          type="number"
          label="المبلغ إلى"
          value={amountTo}
          onChange={(e) => setAmountTo(e.target.value)}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ borderBottom: 1, py: 2, borderColor: colors.light.main }}
      >
        {useMemo(
          () => (
            <AutocompleteWithPagination
              fieldName="first_name"
              limit={crudsService.getLimit()}
              name={"users"}
              value={influencers}
              onChange={(newValue) => {
                setInfluencers(newValue);
              }}
              getData={getUserData}
              label={"المؤثرين"}
            />
          ),
          [crudsService.getLimit(), getUserData, influencers],
        )}
      </Grid>
      <Grid item xs={12}>
        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
          <MDBox mt={0.5}>
            <Switch
              // onChange={changeHandler}
              name="noUser"
              checked={!!donation.noUser}
              onChange={(e) =>
                setDonation({
                  ...donation,
                  [e.target.name]: !donation.noUser,
                })
              }
            />
          </MDBox>
          <MDBox width="80%" ml={0.5}>
            <MDTypography variant="button" fontWeight="regular" color="text">
              فاعل خير
            </MDTypography>
          </MDBox>
        </MDBox>
      </Grid>

      <Grid item xs={12} md={12} lg={12}>
        <MDButton
          variant="gradient"
          color="info"
          size="small"
          type="submit"
          onClick={onFilterHandller}
          mx={1}
        >
          + بحث
        </MDButton>
      </Grid>
    </Grid>
  );
};

export default FilterDonation;
